import React, { FC, useEffect, useState } from 'react';

import Button from '../../../components/button/button';
import PDFViewer, { PdfMenu } from '../../../components/pdfViewer/PDFViewer';
import useReportGenerator from '../../../hooks/useReportGenerator';
import { FormModel } from '../../../models/questionModel';
import useQuestionStore, { FormType } from '../../../store/QuestionStore';
import { useReportStore } from '../../../store/ReportStore';
import { ReportHandler } from '../../ReportPage/Report';
import styles from '../RiskTransfer.module.scss';

const FormSummarySection: FC<ReportHandler> = ({ validChanged }) => {
  const { generateReportHook } = useReportGenerator('summaryReport');
  const { summaryReportPDF } = useReportStore();
  const { getQuestionByForm } = useQuestionStore();

  const allFormType = [
    'liquidation',
    'funding',
    'credit',
    'commodity',
    'currency',
    'interest',
    'operational',
    'disaster',
    'compliance',
    'legal',
  ];

  const [forms, setForms] = useState<FormModel[]>([]);
  const [menus, setMenus] = useState<PdfMenu[]>([]);

  useEffect(() => {
    const allForms: FormModel[] = allFormType.map((f) =>
      getQuestionByForm(f as FormType)
    );

    setForms(allForms);
    setMenus([
      {
        label: 'Generate Form Summary Report',
        callback: () => {
          generateReportHook(allForms);
        },
      },
    ]);
  }, []);

  useEffect(() => {
    validChanged(summaryReportPDF != null);
  }, [summaryReportPDF]);

  return (
    <div className={styles.principalReportMain}>
      <PDFViewer menus={menus} type="summaryReport">
        <Button onClick={() => generateReportHook(forms)}>
          Generate Form Summary Report
        </Button>
      </PDFViewer>
    </div>
  );
};

export default FormSummarySection;
